import React, { memo, forwardRef, useImperativeHandle, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Modal from "@mui/material/Modal";
import PropTypes from "prop-types";

import AppButton from "components/app-button";
import pathnames from "routes/pathnames";

export const AppReminderEligibleInsuranceModal = (props, ref) => {
	const navigate = useNavigate();
	const [data, setData] = useState();
	const [visible, setVisible] = useState(false);

	const onHandleShow = useCallback((obj) => {
		setData(obj);
		setVisible(true);
	}, []);

	const onHandleDismiss = useCallback(() => {
		setVisible(false);
	}, []);

	//prettier-ignore
	const onHandleConfirm = useCallback(async () => {
        const params = data ? `?name=${data.name}` : "";
        navigate(pathnames.insuranceCoverage.coverages + params);
	}, [data, navigate]);

	//prettier-ignore
	useImperativeHandle(ref, () => ({
		onHandleShow: onHandleShow,
		onHandleDismiss: onHandleDismiss,
	}));

	return (
		<Modal classes={{ root: "app-reminder-eligible-insurance-modal" }} open={visible} onClose={onHandleDismiss} aria-labelledby="reminder-eligible-insurance-modal" aria-describedby="reminder-eligible-insurance-modal">
			<div className="reminder-eligible-insurance-modal">
				<div className="reminder-eligible-insurance-modal__main">
					<div className="reminder-eligible-insurance-modal__header">
						<p className="reminder-eligible-insurance-modal__title">Amendment Request</p>
						<p className="reminder-eligible-insurance-modal__description">
							Due to age being above or below the limit, the user is not eligible for coverage. Kindly revise the date of birth or remove the coverage plan from Manage Coverage.
						</p>
					</div>

					<div className="reminder-eligible-insurance-modal__button-container">
						<AppButton type="button" label="Cancel" outline onClick={onHandleDismiss} />
						<AppButton type="button" label="Go to Manage Coverage" onClick={onHandleConfirm} />
					</div>
				</div>
			</div>
		</Modal>
	);
};

export default memo(forwardRef(AppReminderEligibleInsuranceModal));

AppReminderEligibleInsuranceModal.propTypes = {
	ref: PropTypes.object,
};
